import React from 'react';
import {
  Typography,
  Card,
  Button,
  List,
  Avatar,
  Divider,
} from 'antd';
import {
  UserOutlined,
  PhoneOutlined,
  ShoppingOutlined,
  EnvironmentOutlined,
  LogoutOutlined,
  RightOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../store/slices/authSlice';
import { formatPhoneNumber } from '../utils/formatters';
import useTelegram from '../hooks/useTelegram';

const { Title, Text } = Typography;

const ProfilePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user: authUser, isAuthenticated } = useSelector((state) => state.auth);
  const { user: tgUser, onClose } = useTelegram();

  const user = authUser || (tgUser ? { ...tgUser, telegram_username: tgUser.username, role: 'guest' } : null);

  const handleLogout = () => {
    dispatch(logout());
    if (onClose) onClose();
  };

  const menuItems = [
    {
      icon: <ShoppingOutlined />,
      text: 'Mening buyurtmalarim',
      onClick: () => navigate('/orders'),
    },
    {
      icon: <EnvironmentOutlined />,
      text: 'Yetkazib berish manzillari',
      onClick: () => { }, // To be implemented
    },
  ];

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: '24px 0' }}>
      <Title level={2} style={{ marginBottom: 24 }}>
        Profil
      </Title>

      <Card style={{ marginBottom: 24 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <Avatar size={64} icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }} />
            <div>
              <Title level={4} style={{ margin: 0 }}>
                {user ? `${user.first_name || ''} ${user.last_name || ''}`.trim() || 'Foydalanuvchi' : 'Mehmon'}
              </Title>
              {user?.telegram_username && (
                <Text type="secondary">
                  @{user.telegram_username}
                </Text>
              )}
            </div>
          </div>

          <Divider style={{ margin: '8px 0' }} />

          {user?.phone_number && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <PhoneOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
              <Text>
                {formatPhoneNumber(user.phone_number)}
              </Text>
            </div>
          )}

          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <Text type="secondary">
              Rol: {user?.role === 'admin' ? 'Admin' : user?.role === 'seller' ? 'Sotuvchi' : !isAuthenticated ? 'Mehmon' : 'Mijoz'}
            </Text>
          </div>

          {user?.region && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <EnvironmentOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
              <Text>
                {user.region.name}
              </Text>
            </div>
          )}
        </div>
      </Card>

      {isAuthenticated && (
        <Card style={{ marginBottom: 24, padding: 0 }} bodyStyle={{ padding: 0 }}>
          <List
            itemLayout="horizontal"
            dataSource={menuItems}
            renderItem={(item) => (
              <List.Item
                onClick={item.onClick}
                style={{ cursor: 'pointer', padding: '16px 24px' }}
                actions={[<RightOutlined key="arrow" style={{ color: 'rgba(0, 0, 0, 0.45)' }} />]}
              >
                <List.Item.Meta
                  avatar={item.icon}
                  title={item.text}
                />
              </List.Item>
            )}
          />
        </Card>
      )}

      {isAuthenticated ? (
        <Button
          danger
          block
          size="large"
          icon={<LogoutOutlined />}
          onClick={handleLogout}
        >
          Chiqish
        </Button>
      ) : (
        <Button
          type="primary"
          block
          size="large"
          icon={<UserOutlined />}
          onClick={() => navigate('/login')}
        >
          Kirish / Ro&apos;yxatdan o&apos;tish
        </Button>
      )}

      <div style={{ marginTop: 24, textAlign: 'center' }}>
        <Text type="secondary">
          Megadent Shop v1.0.0
        </Text>
      </div>
    </div>
  );
};

export default ProfilePage;
